import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './localization/i18n';
import 'typeface-roboto';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(<App />);
